import { render } from "./trainee_allowance_summary_Report.vue?vue&type=template&id=56a96f4c&ts=true"
import script from "./trainee_allowance_summary_Report.vue?vue&type=script&lang=ts"
export * from "./trainee_allowance_summary_Report.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__